import { useTranslations } from "next-intl";

import type {
  TCatLifestyleCardCat,
  TUseCatLifestyleCard,
} from "./CatLifestyleCard.config";

export const useCatLifestyleCard = (
  cat: TCatLifestyleCardCat,
): TUseCatLifestyleCard => {
  const t = useTranslations("Libs.UI.Components.CatLifestyleCard");
  const tActions = useTranslations("Shared.Actions");

  return {
    healthStats: [
      { icon: "playingCat", label: t("weight"), value: cat.weight },
      { icon: "standingCat", label: t("bodyType"), value: cat.bodyType },
      { icon: "sleepingCat", label: t("lifestyle"), value: cat.lifestyle },
    ],
    healthTitle: t("health"),
    portionSizeTitle: t("portionSize", { name: cat.name }),
    dailyCalories: t("dailyCalories", { calories: cat.calories }),
    editCopy: tActions("edit"),
    editHealthAriaLabel: t("editHealth"),
    editCaloriesAriaLabel: t("editCalories"),
  };
};
